import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import Header from '../../components/common/header/Header';
import Footer from "../../components/common/Footer";
import { Redirect, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import $ from 'jquery';
import { Helmet } from "react-helmet-async";

import {isMobileOnly} from 'react-device-detect';

/**
 * 이벤트/기획전 페이지 표시용
 */
const ContainerBlock = styled.div`
   margin-top: ${isMobileOnly?"60px":"80px"};
`;
const CampaignBlock = styled.div`
        
        & * {margin: 0;padding: 0;border: 0; box-sizing: border-box; display: block;}
        img[usemap] {
            border: none;
            height: auto;
            max-width: 100%;
            width: auto;
        };
`;
const events = ()=> ({
    "2009001": {
      title: 'ㅎㅎㅎ지원이벤트',
      content:'    <div class="eventTab tab" style="margin: 0 auto;max-width: 800px">\n' +
      '        <img id="img_link" src="/assets/images/campaign/2009/page1-1.png" alt="ㅎㅎㅎ프로젝트1" usemap="#eventMap" width="100%" height="auto" border="0" />\n' +
      '        <map name="eventMap" id="img_Map">\n' +
      '            <!--탭메뉴-->\n' +
      '            <area shape="rect" alt="우리집지원혜택" id="tab1Click" coords="0,2070,516,2334" href="#tab1" style="cursor: pointer;" onfocus="this.blur()" />\n' +
      '            <area shape="rect" alt="응모하러가기" id="tab2Click" coords="519,2070,977,2334" href="#tab2" style="cursor: pointer;" onfocus="this.blur()" />\n' +
      '            <area shape="rect" alt="간편견적가이드" id="tab3Click" coords="980,2070,1494,2334" href="#tab3" style="cursor: pointer;" onfocus="this.blur()" />\n' +
      '        </map>\n' +

      '        <img id="tab1" src="/assets/images/campaign/2009/page1-2.png" alt="ㅎㅎㅎ프로젝트 소개" usemap="#eventMap2" width="100%" height="auto" border="0" />\n' +
      '        <!--설문조사하기버튼-->\n' +
      '        <a href="https://forms.gle/gocV5ZXp1kQAqzW78" target="_blank" style="cursor: pointer;">\n' +
      '             <img src="/assets/images/campaign/2009/page1-3.png" alt="설문조사 하러가기" width="100%" height="auto" border="0" />\n' +
      '        </a>\n' +
      '        <img src="/assets/images/campaign/2009/page1-4.png" alt="bg" width="100%" height="auto" border="0" />\n' +
      '        <img id="tab2" src="/assets/images/campaign/2009/page1-5.png" alt="ㅎㅎㅎ응모방법" width="100%" height="auto" border="0" />\n' +
      '        <!--견적요청하기버튼-->\n' +
      '        <a href="https://www.odgagu.co.kr/ct" target="_blank" style="cursor: pointer;">\n' +
      '            <img src="/assets/images/campaign/2009/page1-6.png" alt="견적요청 하러가기" width="100%" height="auto" border="0" />\n' +
      '        </a>\n' +
      '        <img src="/assets/images/campaign/2009/page1-7.png" alt="어디가구 인스타소개" width="100%" height="auto" border="0" />\n' +
      '        <!--견적가이드보러가기-->\n' +
      '        <a href="/campaign/open/2009002" target="_self" style="cursor: pointer;">\n' +
      '            <img id="tab3" src="/assets/images/campaign/2009/page1-8.png" alt="견적가이드 보러가기" width="100%" height="auto" border="0" />\n' +
      '        </a>\n' +
      '        <img src="/assets/images/campaign/2009/page1-9.png" alt="푸터" width="100%" height="auto" border="0" />\n' +
      '    </div>',
      action:()=>{
        //반응형맵핑1
        window.onload = function() {
          var ImageMap = function(map, img) {
              var n, areas = map.getElementsByTagName('area'),
                len = areas.length,
                coords = [],
                previousWidth = 1499;
              for (n = 0; n < len; n++) {
                coords[n] = areas[n].coords.split(',');
              }
              this.resize = function() {
                var n, m, clen, x = img.offsetWidth / previousWidth;
                for (n = 0; n < len; n++) {
                  clen = coords[n].length;
                  for (m = 0; m < clen; m++) {
                    coords[n][m] *= x;
                  }
                  areas[n].coords = coords[n].join(',');
                }
                previousWidth = document.body.clientWidth;
                return true;
              };
              window.onresize = this.resize;
            },
            imageMap = new ImageMap(document.getElementById('img_Map'), document.getElementById('img_link'));
          imageMap.resize();
          return;
        };
        //탭클릭시 스크롤 이동이벤트
        $(function() {
          var scrollTop = $(window).scrollTop();
          //탭1
          $('#tab1Click').click(function() {
            var captionTop = $('#tab1').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
          //탭2
          $('#tab2Click').click(function() {
            var captionTop = $('#tab2').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
          //탭3
          $('#tab3Click').click(function() {
            var captionTop = $('#tab3').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
        });

      }
    },
    "2009002":{
      title: 'ㅎㅎㅎ 견적가이드',
      content:'<div class="eventTab tab" style="margin: 0 auto;max-width: 800px;">\n' +
        '        <img id="img_link" src="/assets/images/campaign/2009/page2-1.png" alt="ㅎㅎㅎ프로젝트2" usemap="#eventMap" width="100%" height="auto" border="0" />\n' +
        '        <map name="eventMap" id="img_Map">\n' +
        '            <!--탭메뉴-->\n' +
        '            <area shape="rect" alt="우리집지원혜택" id="tab1Click" coords="0,2070,516,2334" href="#tab1" style="cursor: pointer;" onfocus="this.blur()" />\n' +
        '            <area shape="rect" alt="응모하러가기" id="tab2Click" coords="519,2070,977,2334" href="#tab2" style="cursor: pointer;" onfocus="this.blur()" />\n' +
        '            <area shape="rect" alt="간편견적가이드" id="tab3Click" coords="980,2070,1494,2334" href="#tab3" style="cursor: pointer;" onfocus="this.blur()" />\n' +
        '        </map>\n' +
        '        <img src="/assets/images/campaign/2009/page2-2.png" alt="가구견적가이드" width="100%" height="auto" border="0" />\n' +
        '        <!--        유튜브영상-->\n' +
        '        <div class="video_container" style="position: relative;left: 5%;top:0; padding-bottom: 56.25%;height:0;margin-bottom: 8vw;width: 90%">\n' +
        '            <iframe width="1022" height="575" src="https://www.youtube.com/embed/AzvMnbYcX84?autoplay=1&amp;playlist=oiZxSFbeMHQ&amp;loop=1&mute=1&controls=0&disablekb=1&loop=1&color=white&rel=0" frameborder="0" allowfullscreen style="position: absolute;top: 0;left: 0%;width: 100%;height: 90%;"></iframe>\n' +
        '        </div>\n' +
        '        <img id="tab2" src="/assets/images/campaign/2009/page2-3.png" alt="견적 가이드화면" width="100%" height="auto" border="0" />\n' +
        '        <a href="/campaign/open/2009001" target="_self" style="cursor: pointer;">\n' +
        '            <img id="tab1" src="/assets/images/campaign/2009/page2-4.png" alt="ㅎㅎㅎ지원이벤트 보러가기" width="100%" height="auto" border="0" />\n' +
        '        </a>\n' +
        '        <img src="/assets/images/campaign/2009/page2-5.png" alt="푸터" width="100%" height="auto" border="0" />\n' +
        '    </div>\n',
      action:()=>{
        //반응형맵핑
        window.onload = function() {
          var ImageMap = function(map, img) {
              var n, areas = map.getElementsByTagName('area'),
                len = areas.length,
                coords = [],
                previousWidth = 1499;
              for (n = 0; n < len; n++) {
                coords[n] = areas[n].coords.split(',');
              }
              this.resize = function() {
                var n, m, clen, x = img.offsetWidth / previousWidth;
                for (n = 0; n < len; n++) {
                  clen = coords[n].length;
                  for (m = 0; m < clen; m++) {
                    coords[n][m] *= x;
                  }
                  areas[n].coords = coords[n].join(',');
                }
                previousWidth = document.body.clientWidth;
                return true;
              };
              window.onresize = this.resize;
            },
            imageMap = new ImageMap(document.getElementById('img_Map'), document.getElementById('img_link'));
          imageMap.resize();
          return;
        };
        //탭클릭시 스크롤 이동이벤트
        $(function() {
          var scrollTop = $(window).scrollTop();
          //탭1
          $('#tab1Click').click(function() {
            var captionTop = $('#tab1').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
          //탭2
          $('#tab2Click').click(function() {
            var captionTop = $('#tab1').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
          //탭3
          $('#tab3Click').click(function() {
            var captionTop = $('#tab2').offset().top;
            $('html, body').animate({
              scrollTop: captionTop
            }, 600);
            return false;
          });
        });
      }
    }
});

const CampaignHome = ({ match }) => {

    return (
      <ContainerBlock>
        <Helmet>
          <title>{events()[match.params.id].title}</title>
        </Helmet>
        <Header />
      <CampaignBlock>
          <div dangerouslySetInnerHTML={{__html: events()[match.params.id].content}}>{events()[match.params.id].action()}</div>
      </CampaignBlock>
        <Footer />
      </ContainerBlock>
    );
};

export default CampaignHome;
